//BT-115298 : Implementing search functionality for Recommendation : ManasaB : 14/08/2023 - Start
import { memo } from 'react';
import { BzChip, BzButton, BzCard } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import PriceFormat from '../Recommendations/PriceFormat';
import DontMissChip from '../DontMiss/DontMissChip';
const TabRecommContent = ({ arrRecommScrips, handleOnClickScrip, onKeyDown = () => { }, nActiveCard, scripDetails, removeScrips, addScrips, onBuySellClick, onBuySellClickRecomm, ...props }) => {

    return (
        <>
            <Container className='p-0 px-3'>
                {arrRecommScrips?.length > 0 && arrRecommScrips?.map((each, i) =>
                    <Row className='g-0' onKeyDown={onKeyDown}>
                        <Col>
                            <BzCard key={i} className='p-0 py-3 bdr-card-btm'>
                                <Row className='g-0'>
                                    <Col md={5} className='d-flex justify-content-start align-items-center'>
                                        <div className='font-medium font-size4 color-text cursor-pointer text-uppercase me-2'>{each.companyName}</div>
                                        <div className='chips-wrap'>
                                            <BzChip className='exchange-chip me-2'>{each.exChangeName}</BzChip>
                                        </div>
                                        <div className='font-regular font-size4 color-subtext me-2'>{each.quotienType}</div>
                                        {each?.isHoldings === true ? <div className='icon-16 icon-portfolio icon-dark'></div> : null}
                                    </Col>
                                    {/* Bhagyashri P [07-12-2023] : class changes Starts */}
                                    <Col md={4} className='d-flex justify-content-start align-items-center'>
                                        <div className='recocard align-items-center p-2 font-medium font-size2 color-text text-wrap cursor-pointer'>
                                            <PriceFormat eachCompany={each} />
                                        </div>
                                    </Col>
                                    {each?.sRecoDetails?.length <= 1 && <Col md={3} className='d-flex justify-content-end align-self-start'>
                                        <BzButton style={{ border: nActiveCard === i ? 'solid 1px black' : null }} className={`btn ${each?.nBuySell === "BUY" ? 'btn-positive' : 'btn-negative'} btn-sm text-capitalize`} onClick={(e) => { e.stopPropagation(); onBuySellClickRecomm(each.nBuySell, each); }} >{each.nBuySell}</BzButton>
                                    </Col>} {/* Bhagyashri P [07-12-2023] : class changes Ends */}
                                </Row>
                                <Row className='g-0 mt-2'>
                                    <Col md={5} className='d-flex justify-content-start align-items-center'>
                                        <div className='chips-wrap'>
                                            <BzChip className='chips primary-chip me-2 mb-2'>{each?.sLongShort}</BzChip>
                                            {
                                                each?.sRecoTag?.length > 0 &&
                                                <BzChip className='chips default-chip me-2 mb-2'>{each?.sRecoTag}</BzChip>
                                            }
                                            {
                                                each?.dontMiss && <DontMissChip value={each?.dontMiss} isShowAllChips />
                                            }
                                        </div>
                                    </Col>
                                    <Col md={4} className='d-flex justify-content-start align-items-center'>
                                        {/* <PriceBar eachCompany={each} ltp={each?.ltp} stopLossPrice={each.calSLPrice} targetPrice={each.calSQPrice} enteredPrice={each.EnteredPrice} /> */}
                                    </Col>
                                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                                        <div className='d-flex cursor-pointer'>
                                            <div className='icon-20 icon-pdf background-textual-link-withicon me-2'></div>
                                            <div className='font-medium font-size2 color-textual-link-withicon'>Analytic Report</div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-4'>
                                    <Col md={5} className='d-flex justify-content-start align-items-center'>
                                        <div className='font-regular font-size1 color-text me-1'>Recommendation on</div>
                                        <div className='font-regular font-size2 color-subtext'>{each.entryDate}</div>
                                    </Col>
                                    <Col md={4} className='d-flex justify-content-start'>
                                        <div className='d-flex align-items-center cursor-pointer'>
                                            <div className='notification-count font-regular'>2</div>
                                            <div className='font-regular font-size3 color-text ms-2'>Follow-up Recommendations</div>
                                        </div>
                                    </Col>
                                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                                        <div className='font-regular font-size1 color-text me-1'>Valid till</div>
                                        <div className='font-regular font-size2 color-subtext'>{each.expiryDate}</div>
                                    </Col>
                                </Row>
                            </BzCard>
                        </Col>
                    </Row>
                )
                }
            </Container>

        </>
    );
};

export default memo(TabRecommContent);

//BT-115298 : Implementing search functionality for Recommendation : ManasaB : 14/08/2023 - End